<template>
    <div>

      <p> <h3> Stripe API 功能测试  点击后 显示测试结果!  </h3>
      </p>
      
      <div style="border: 1px solid #ccc; padding: 20px; margin: 20px;">
      <el-button  type="primary"    @click="getAllCustomer">全量更新 Customer  </el-button> <br><br>
      <el-button  type="primary"  @click="getNewCustomer">增量更新Customer 并写入数据库 </el-button> <br><br>
      <el-button  type="primary"  @click="updateCustomer">更新最近一段时间的 Customer 状态 </el-button>
    </div>



    <div style="border: 1px solid #ccc; padding: 20px; margin: 20px;">
..............
    </div>


      <div>{{ responseData }}</div>
    </div>

  </template>




<script>


export default {
  data() {
    return {
      responseData: '',
    
    };
  },
  methods: {
    getAllCustomer() {
     this.$http.get('/da/get_all_stripe_customer')
        .then(response => {
          this.responseData = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getNewCustomer() {
     this.$http.get('/da/get_new_stripe_customer')
        .then(response => {
          this.responseData = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },







    getSubsTrailInfo() {          // 发往后端,分析订阅别试用信息
     this.$http.get('/da/sync_subs_trial')
        .then(response => {
          this.responseData = response.data;
        // this.buttonText = '再次获取数据';
        })
        .catch(error => {
          console.error(error);
        });
    },




/////////////

////////////

  }
};
</script>